const DateFormat = {
	fullDate: 'DD-MM-YYYY',
};

export default DateFormat;
